import _ from 'lodash';
import {GEO_TYPES} from '../../../../serp/constants';

angular.module('cian.filter')
  .factory('FilterConverterService', [
    '$log',
    '$window',
    'RegionUtilsService',
    'FilterTermsService',
    'HighwaysService',
    'GeoUtils',
    'MetroService',
    'FilterObjectTypeService',
    function ($log, $window, RegionUtilsService, FilterTermsService, HighwaysService, GeoUtils, MetroService, FilterObjectTypeService) {
      const service = this;

      service.convertFromBackend = (baseFilter, filter, selectedRegions, customFilterRules) => {
        const newFilter = angular.copy(filter);
        // Защищаем исходный фильтр от изменений
        filter = null;

        // Если выбранный регион продублирован в geo, то выкидываем его
        _.remove(newFilter.geo.value, geoItem => (
          geoItem.type === GEO_TYPES.LOCATION &&
          _.some(RegionUtilsService.getInitialRegions(), { id: geoItem.id })
        ));

        /*
         Конвертируем category в правильный тип объекта.
         Например, для готового бизнеса:
         category = ['businessSale'] => office_type = [10]
         */
        if (angular.isArray(_.get(newFilter, 'category.value'))) {
          /** @type {ObjectType[]} */
          const convertedObjectTypes = _.map(newFilter.category.value, cat => {
            let catName = cat.replace('Rent', '').replace('Sale', '').replace('daily');
            catName = catName[0].toLowerCase() + catName.substr(1);
            return FilterObjectTypeService.getObjectTypeByName(catName);
          });

          const filterParamName = convertedObjectTypes[0].filterParamName;
          newFilter[filterParamName] = {
            type: 'terms',
            value: _.map(convertedObjectTypes, 'filterParamValue'),
          };

          newFilter.category.value = null;
        }

        // Удаляем из гео дублирующиеся объекты
        // (например, со старых фильтров одна станция метро может придти несколько раз)
        newFilter.geo.value = _.uniqBy(newFilter.geo.value, g => g.type + g.id);

        // Удаляем некорректные полигоны
        _.remove(newFilter.geo.value, g =>
          g.type === GEO_TYPES.POLYGON && !GeoUtils.areCoordinatesCorrect(g.geoObject)
        );

        // Если выбран ЖК + от застройщика, то проставляем тип здания "Новостройка"
        if (_.get(newFilter, 'from_developer.value') &&
          _.some(newFilter.geo.value, { type: GEO_TYPES.NEWOBJECT })) {
          newFilter.building_status = {
            type: 'term',
            value: 2
          };
        }

        // Конвертируем способы до метро:
        // 1. пешком от агента -> пешком
        // 2. транспортом от агента -> транспортом
        if (newFilter.only_foot) {
          switch(newFilter.only_foot.value) {
            case '1': // 1
              newFilter.only_foot.value = '2';
              break;
            case '-1': // 2
              newFilter.only_foot.value = '-2';
              break;
          }

          // Проставляем время, если не указано
          if (!newFilter.foot_min) {
            newFilter.foot_min = {
              type: 'range',
              value: {
                lte: MetroService.FOOT_MIN_DEFAULT
              }
            }
          }
        }

        // Конвертируем старый тип земли в новый
        // (значения одинаковые, названия полей разные)
        if (newFilter.land_type) {
          if (newFilter.land_status) newFilter.land_status.value = newFilter.land_type.value;
          newFilter.land_type.value = null;
        }

        // БЦ может приходить в 2 разных полях:
        // bs_center - массив id бизнес-центров
        // bs_center_id - id единственного БЦ
        // Используем только bs_center, поэтому конвертируем в него
        const BCId = _.get(newFilter, 'bs_center_id.value');
        if (BCId) {
          newFilter.bs_center.value = [BCId];
          newFilter.bs_center_id.value = null;
        }

        // Сгруппированные фильтры
        angular.forEach(customFilterRules, function (customFilterRule) {
          if (customFilterRule.checkCondition()) {
            const originalFilter = newFilter[customFilterRule.original];
            if (originalFilter) {
              newFilter[customFilterRule.custom] = {
                type: originalFilter.type,
                value: []
              };

              angular.forEach(FilterTermsService[customFilterRule.custom], function (customItem) {
                const customValues = customItem.value;
                /*
                 Если все значения кастомного фильтра есть в исходном,
                 то считаем кастомный выбранным
                 */
                if (_.intersection(originalFilter.value, customValues).length === customValues.length) {
                  newFilter[customFilterRule.custom].value.push(customValues);
                }
              });

              // Удаляем исходный фильтр
              newFilter[customFilterRule.original].value = null;
            }
          }
        });

        /*
         Особые случаи
         */

        // Тип санузла может придти 0, но это то же, что null
        if (newFilter.wc_type && newFilter.wc_type.value === 0) {
          newFilter.wc_type.value = null;
        }

        // Если указан тип, то количество санузлов может придти 0
        if (newFilter.wc && newFilter.wc.value.gte === 0) {
          newFilter.wc.value = {
            gte: null,
            lte: null
          };
        }

        // Преобразуем группы шоссе в направления
        if (newFilter.geo) {
          const filterHighways = _.filter(newFilter.geo.value, { type: GEO_TYPES.HIGHWAY });

          if (filterHighways.length) {
            const highwayRegion = RegionUtilsService.findRegionWithHighway(selectedRegions);

            if (highwayRegion) {
              HighwaysService.getHighways(highwayRegion.id)
                .then(function (directions) {
                  angular.forEach(directions, function (direction) {
                    // Если все шоссе направления выбраны
                    if (!_.differenceBy(direction.highways, filterHighways, 'id').length) {
                      newFilter._highway_directions = newFilter._highway_directions || baseFilter._highway_directions;

                      // TODO дублирует логику toggleDirection из highway-browser.ctrl
                      // вынести в HighwayService?

                      // Добавляем направление
                      newFilter._highway_directions.value.push(direction);

                      // А все его шоссе удаляем
                      angular.forEach(direction.highways, function (h) {
                        _.remove(newFilter.geo.value, {
                          type: GEO_TYPES.HIGHWAY,
                          id: h.id
                        });
                      });
                    }
                  });
                });
            }
          }
        }

        return newFilter;
      };

      service.convertToBackend = (baseFilter, query, customFilterRules) => {
        /*
         Удаляем параметры с пустыми значениями
         TODO должен удалять только параметры равные дефолтным,
         а не просто пустые значения. Надо сравнивать с baseFilter
         */
        const newQuery = _.transform(query, function(memo, v, k) {
          const value = v.value;
          if (k === '_type') {
            memo[k] = v;
          } else if (angular.isDefined(value) && value !== null) {
            const type = v.type;
            let newValue;
            if (type === 'range') {
              if (value.gte || value.lte) {
                newValue = {};
                if (value.gte) {
                  newValue.gte = value.gte;
                }
                if (value.lte) {
                  newValue.lte = value.lte;
                }
              }
            } else if (type === 'terms' && value.length) {
              newValue = angular.copy(value);
            } else if (type === 'geo' && value.length) {
              newValue = value.map(geoItem => {
                if (geoItem.type === GEO_TYPES.POLYGON) {
                  return {
                    type: 'polygon',
                    name: geoItem.text,
                    coordinates: geoItem.geoObject.source.geometry.coordinates[0].map(
                      coordinatesItem => coordinatesItem.map(String)
                    ),
                  }
                } else if (geoItem.type === GEO_TYPES.CIRCLE) {
                  return {
                    type: 'distance',
                    name: geoItem.text,
                    radius: geoItem.geoObject.source.geometry.radius,
                    center: geoItem.geoObject.source.geometry.coordinates.map(String),
                  };
                } else {
                  return {
                    type: geoItem.type,
                    id: geoItem.id
                  };
                }
              });
            } else if (type === 'term') {
              newValue = value;
            }

            if (angular.isDefined(newValue)) {
              memo[k] = _.extend({}, v, {
                value: newValue
              });
            }
          }
        }, {});

        // Преобразуем сгруппированные фильтры
        angular.forEach(customFilterRules, function (customFilterRule) {
          if (customFilterRule.checkCondition(newQuery)) {
            const custom = newQuery[customFilterRule.custom];
            if (custom) {
              const originalFilter = {
                type: custom.type,
                value: []
              };

              angular.forEach(custom.value, function (value) {
                originalFilter.value = originalFilter.value.concat(value);
              });

              newQuery[customFilterRule.original] = originalFilter;

              delete newQuery[customFilterRule.custom];
            }
          }
        });

        /*
         Особые случаи
         */

        // Если указан тип санузла, надо обязательно отправлять количество санузлов
        // (иначе фильтр проигнорируется бэком)
        if (newQuery.wc_type && !newQuery.wc) {
          newQuery.wc = {
            type: 'range',
            value: {
              gte: 1
            }
          };
        }

        // Преобразуем направления в шоссе
        if (newQuery._highway_directions) {
          newQuery.geo = newQuery.geo || _.extend(
              // Сохраняем формат geo
              {},
              baseFilter.geo,
              {value: []}
            );

          angular.forEach(newQuery._highway_directions.value, function (direction) {
            angular.forEach(direction.highways, function (highway) {
              newQuery.geo.value.push({
                type: GEO_TYPES.HIGHWAY,
                id: highway.id,
                text: highway.name
              });
            });
          });

          delete newQuery._highway_directions;
        }

        if (!newQuery.sort) {
          delete newQuery.quality;
        }

        return newQuery;
      };

      return service;
    }]);



// WEBPACK FOOTER //
// ./src/components/filter/src/scripts/cian.filter.converter.service.js